import getColor from '~/lib/getColor'
import {
    PROCESSID_3DP,
    PROCESSID_CNC,
    PROCESSID_DC,
    PROCESSID_RTV,
    PROCESSID_IM,
    PROCESS_DISPLAY_CNC,
    PROCESS_DISPLAY_3DP,
    PROCESS_DISPLAY_DC,
    PROCESS_DISPLAY_RTV,
    PROCESS_DISPLAY_IM,
} from '~/lib/partsConstants'

export const BORDER = `1px solid ${getColor('blackAlpha15')}`
export const ADDRESS_REQUIRED = 'Address required'

export const SEE_CHECKOUT = 'See checkout'

export const SEE_CHECKOUT_STYLE = {
    color: getColor('blackAlpha25'),
    fontSize: '14px',
    fontWeight: 500,
}

const VALUE_STYLE = {
    color: getColor('blackAlpha65'),
    fontWeight: 500,
}

export const DEFAULT_SUMMARY_ROW_VALUE_STYLE = {
    ...VALUE_STYLE,
    fontSize: '14px',
}

export const FREE_SHIPPING_ROW_VALUE_STYLE = {
    color: getColor('success'),
    fontWeight: 500,
    fontSize: '14px',
}

export const PREFERRED_PRICING_SUMMARY_ROW_STYLE = {
    color: getColor('primary6'),
    fontWeight: 500,
    fontSize: '14px',
}

export const PRICING_LINE_ITEM_STYLE = {
    color: getColor('blackAlpha65'),
    fontSize: '14px',
    fontWeight: 400,
}

export const TOTAL_STYLE = {
    color: getColor('blackAlpha85'),
    fontSize: '16px',
    fontWeight: 500,
}

export const DEPOSIT_REQUIRED_STYLE = {
    color: getColor('blackAlpha85'),
    fontSize: '16px',
    fontWeight: 500,
}

export const HOLIDAY_ALERT_STYLE = {
    color: getColor('warningIcon'),
    fontSize: '14px',
    fontWeight: 500,
}

export const ZIPCODE_REQUIRED_STYLE = {
    color: getColor('blackAlpha25'),
    fontSize: '14px',
    fontWeight: 500,
    marginBottom: '21px',
}

export const BREAKDOWN_LABEL_STYLE = {
    color: getColor('blackAlpha45'),
    textIndent: '8px',
}

export const BREAKDOWN_VALUE_STYLE = {
    color: getColor('blackAlpha45'),
    textIndent: '8px',
    fontWeight: 300,
}

export const BALANCE_LABEL_STYLE = {
    color: getColor('blackAlpha65'),
    fontSize: '14px',
    fontWeight: 400,
}

export const BALANCE_VALUE_STYLE = {
    color: getColor('blackAlpha65'),
    fontSize: '14px',
    fontWeight: 400,
}

export const PROCESS_MAPPING: { [x: string]: string } = {
    [PROCESSID_CNC]: PROCESS_DISPLAY_CNC,
    [PROCESSID_3DP]: PROCESS_DISPLAY_3DP,
    [PROCESSID_DC]: PROCESS_DISPLAY_DC,
    [PROCESSID_RTV]: PROCESS_DISPLAY_RTV,
    [PROCESSID_IM]: PROCESS_DISPLAY_IM,
}

export const DETAIL_POPOVER_TITLE_TAX = 'Tax'

export const DETAIL_POPOVER_CONTENT_TAX =
    'Tax is subject to change based on the final shipping address and date of shipment.'

export const ORDER_TOTAL_POPOVER_TITLE_TAX = 'Order total'

export const ORDER_TOTAL_POPOVER_CONTENT_TAX = `The total amount is reflective of quantities, fees, and paid deposit at the time of checkout, and does not reflect any potential change to the order after the checkout.
Import fees are not included.`

export const TOOLING_DEPOSIT_POPOVER_TITLE = 'Tooling deposit'

export const TOOLING_DEPOSIT_POPOVER_CONTENT =
    'Purchase orders require a tooling deposit of 50% of the total tooling price (subject to approval for each order). All other payment methods require the payment of the total order amount at checkout.'

export const BALANCE_POPOVER_TITLE_TAX = 'Balance after deposit'

export const BALANCE_POPOVER_CONTENT_TAX =
    'Outstanding balance will be invoiced upon approval of samples or 6 months from kickoff date.'

export const QUOTE_DETAILS_PAGE = 'quote-details-page'
